import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import request from "../../Apis/request";
import { BaseURL, uniqueToken } from "../../api/DataApis";
import axios from "axios";
import { use } from "i18next";
import { uniqueId } from "react-bootstrap-typeahead/types/utils";
import Select2 from "react-select2-wrapper";
import $ from 'jquery';
import Select from 'react-select';



function Add() {
document.title = "charger | Add";
  let navigate = useNavigate();

  const params = useParams();
  let StationID = params.qid;

  console.log("stationID", StationID);


  // Destructure the data passed from the previous component
  // const UserEditData = location?.state?.UserEditData;

  // Log to ensure StationEditData is availabl

  // State variables
  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [loading, setLoading] = useState(false);

  const [VehicleNumber, setVehicleNumber] = useState([]);
  const [selectedParent, setselectedParent] = useState([]);
  const [userType, setUserType] = useState([]);
  const [LatitudePoints, setLatitudePoints] = useState([]);
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [IMEINumber, setIMEINumber] = useState([]);
  const [AmarRajaChargerID, setAmarRajaChargerID] = useState([]);
  const [simNumber, setSimNumber] = useState([]);
  const [ChipID, SetChipID] = useState([]);
  const [BookingAmount, setBookingAmount] = useState([]);
  const [BookingCancelAmount, setBookingCancelAmount] = useState([]);
  const [ChargerEstimatedBidPrice, setChargerEstimatedBidPrice] = useState([]);
  const [Address, setAddress] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('');
  const [selectedState, setSelectedState] = useState('');
  const [selectedCity, setSelectedCity] = useState('');
  const [Tax, setTax] = useState([]);
  const [othercharges, setothercharges] = useState([]);
  const [PerUnitPricewithoutGST, setPerUnitPricewithoutGST] = useState([]);
  const [PerUnitPricewithGST, setPerUnitPricewithGST] = useState([]);
  const [LocalHourse, setLocalHourse] = useState([]);
  const [SecurityCode, setSecurityCode] = useState([]);
  const [ChargerconType, setChargerconType] = useState([]);
  const [ConnectorsType, setConnectorsType] = useState([]);
  const [connectorIDList, setConnectorIDList] = useState([]); 
  const [Power, setPower] = useState([]);
  const [SelectServiceProvider, setSelectServiceProvider] = useState([]);
  const [selectAmenity, setselectAmenity] = useState([]);
  const [SelectVechicle, setSelectVechicle] = useState([]);
  const [PaymentType, setPaymentType] = useState([]);
  const [ChargerType, setChargerType] = useState([]);
  const [Maxvoltage, setMaxvoltage] = useState([]);
  const [Maxcurrent, setMaxcurrent] = useState([]);
  const [MinimumCOneValue, setMinimumCOneValue] = useState([]);
  const [stationName, setStationName] = useState([]);
  const [ChargerData, setChargerData] = useState([]);
  const [PowerListing, setPowerListing] = useState([]);
  const [Vehiclesnames, setVehiclesnames] = useState([]);
  const [AmenitiesTypes, setAmenitiesTypes] = useState([]);
  
  const [chargingTypesData, setchargingTypesData] = useState([]);
  const [selectedConnectorType, setSelectedConnectorType] = useState([]);
  const [selectedConnectors, setSelectedConnectors] = useState([]);
  const [connectorOptions, setConnectorOptions] = useState([]);
  const [ChargerMettalicProperty, SetChargerMettalicProperty] = useState([]);

  const handleChargerMetallicProperty = (e) => {
    SetChargerMettalicProperty(e.target.value);
  }
  
 

 const handleConnectorTypeChange = (selectedOptions) => {
    setSelectedConnectors(selectedOptions || []); // Use selectedOptions directly
    console.log('Selected Values:', selectedOptions); // Log the selected values
  };
  



  console.log("selectedConectors", selectedConnectors);
  // Populate form fields with existing data on load


  // Handlers for form fields
  const handleName = (e) => setName(e.target.value);
  const handleLatitudePoints = (e) => setLatitudePoints(e.target.value);
  const handleLongitudePoints = (e) => setLongitudePoints(e.target.value);
  const handleFileChange = (e) => setSelectedFile(e.target.files[0]);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleIMEINumberChange = (e) => setIMEINumber(e.target.value);
  const handleAmarRajaPoints = (e) => setAmarRajaChargerID(e.target.value);
  const handleSimNumberChange = (e) => setSimNumber(e.target.value);
  const handleChipNumberChange = (e) => SetChipID(e.target.value);
  const handleBookingAmountChange = (e) => setBookingAmount(e.target.value);
  const handlecancelBookingAmountChange = (e) => setBookingCancelAmount(e.target.value);
  const handleChargerEstimatedBidPriceChange = (e) => setChargerEstimatedBidPrice(e.target.value);
  const handletaxChange = (e) => setTax(e.target.value);
  const handleotherchargesChange = (e) => setothercharges(e.target.value);
  const handlePerUnitPricewithoutGSTChange = (e) => setPerUnitPricewithoutGST(e.target.value);
  const handlePerUnitPricewithGSTChange = (e) => setPerUnitPricewithGST(e.target.value);
  const handleLocalHourseChange = (e) => setLocalHourse(e.target.value);
  const handleSecurityCodeChange = (e) => setSecurityCode(e.target.value);
  const handleChargerconTypeChange = (e) => setChargerconType(e.target.value);
  // const handleConnectorsTypeChange = (e) => setConnectorsType(e.target.value);
  const handlePowerChange = (e) => setPower(e.target.value);
  const handleServiceProviderChange = (e) => setSelectServiceProvider(e.target.value);
  const handleAmenityChange = (selectedchoices) => {
    // const selectedAmmenity = selectedchoices ? selectedchoices?.map(option => option.value) : [];
setselectAmenity(selectedchoices)};

  const handleVechicleChange = (e) => setSelectVechicle(e.target.value);
  const handlePaymentTypeChange = (e) => setPaymentType(e.target.value);
  const handleChargerTypeChange = (e) => setChargerType(e.target.value);
  const handleMaxvoltageChange = (e) => setMaxvoltage(e.target.value);
  const handleMaxcurrentChange = (e) => setMaxcurrent(e.target.value);
  const handleMinimumCOneValueChange = (e) => setMinimumCOneValue(e.target.value);
  const handleStationNameChange = (e) => setStationName(e.target.value);
  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleStatusType = (e) => setSelectedStatusType(e.target.value);


  const handleConnectorIDChange = async (e) => {
    const selectedConnectorID = e.target.value;
    setChargerconType(selectedConnectorID);

    if (selectedConnectorID) {
      try {
        const response = await axios.get(
          `${BaseURL}/master/?parent_id=${selectedConnectorID}`,
          {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          }
        );
        // Assuming response.data.data holds the array of connectors in the correct format
        const fetchedConnectorOptions = response.data.data.map((connector) => ({
          value: connector._id, // Adjust according to your API data structure
          label: connector.title, // Adjust according to your API data structure
        }));
      
        setConnectorOptions(fetchedConnectorOptions); // Update the connector options for Select
        setConnectorIDList(response.data.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  };

 
  
  


  const FetchChargerData = async () => {
    setLoading(true);

    try {
      const res = await request({
        url: `${BaseURL}/master/charger-type-0`,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      if (res && res?.data) {

        setChargerData(res?.data);
      } else {
        setChargerData([]); // If no data, ensure filteredData is empty
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setChargerData([]); // In case of error, set filteredData to empty
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchChargerData();
  }, []);




  useEffect(() => {
    // Fetch countries on component mount
    const fetchPowerListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/power-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setPowerListing(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchPowerListing();
  }, []);
  useEffect(() => {
    const fetchAmenityListing = async () => {
      try {
    
  
        const response = await axios.get(`${BaseURL}/master/amenites-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
  
        // Assuming the API returns an array of amenities
        const formattedAmenities = response.data.data.map(amenity => ({
          value: amenity._id,  // Assuming _id is the unique identifier for each amenity
          label: amenity.title,  // Assuming name is the display name for each amenity
        }));
        
        setAmenitiesTypes(formattedAmenities);
        Swal.close();
      } catch (error) {
        console.error("Error fetching amenities:", error);
    
      }
    };
  
    fetchAmenityListing();
  }, []);
  
  useEffect(() => {
    // Fetch countries on component mount
    const fetchVehicleNamesListing = async () => {
      try {
        const response = await axios.get(`${BaseURL}/master/vehicles-0`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        setVehiclesnames(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchVehicleNamesListing();
  }, []);
  const selectedConnectorIDs = selectedConnectors.map(connector => connector.value);
  console.log("selectedOptionsssssss", selectedConnectorIDs);

console.log("connectorIDList", connectorIDList);
console.log("selectedConnectorType", selectedConnectorType);





  // Function to handle the update request
  const AddCharger = async () => {
    // Show loader before API call
    Swal.fire({
      title: 'Adding Charger...',
      text: 'Please wait',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  
    // Create a new FormData object
    let formData = new FormData();
    formData.append("charger_name", Name);
    formData.append("status", selectedStatusType);
    formData.append("imei_number", IMEINumber);
    formData.append("AmarRaja_charger_id", AmarRajaChargerID);
    formData.append("sim_number", simNumber);
    formData.append("chip_id", ChipID);
    formData.append("booking_amount", BookingAmount);
    formData.append("booking_cancel_amount", BookingCancelAmount);
    formData.append("charger_estimated_bid_price", ChargerEstimatedBidPrice);
    formData.append("tax", Tax);
    formData.append("other_charger", othercharges);
    formData.append("per_unit_price_without_gst", PerUnitPricewithoutGST);
    formData.append("per_unit_price_with_gst", PerUnitPricewithGST);
    formData.append("local_hours", LocalHourse);
    formData.append("security_code", SecurityCode);
    formData.append("max_voltage", Maxvoltage);
    formData.append("max_current", Maxcurrent);
    formData.append("minimum_c_one_value", MinimumCOneValue);
    if (selectAmenity.length > 0) {
      selectAmenity.forEach((amenity) => {
          formData.append("select_amenity_id[]", amenity?.value); // Append each item individually
      });
  }
  
 
    
    if (Power.length >0) {
    formData.append("select_power_id", Power);
    }
    if (ChargerconType.length >0) {
    formData.append("master_charger_type_id", ChargerconType);
    }
    if (SelectVechicle.length >0) {
    formData.append("select_vehicle_id", SelectVechicle);
    }
    if( ChargerType.length >0 ) {
    formData.append("master_station_charger_id", ChargerType);
    }
    if (ChargerMettalicProperty) {
      formData.append("charger_ion_type",ChargerMettalicProperty );
    }
    formData.append("station_id", StationID);
    for (var i = 0; i < selectedConnectorIDs.length; i++) {
      formData.append(`connectors[${i}][master_connector_id]`, selectedConnectorIDs[i]);
    }
    
    console.log("Insie this funciuton");

    if (selectedFile) {
      formData.append("charger_image", selectedFile);
    }
  
    // if (selectedFile) {
    //   formData.append("charger_image", selectedFile);
    // }
  
    try {
      // Make the API request
      let response = await axios.post(
        `${BaseURL}/chargers/add`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
            "Content-Type": "multipart/form-data",
            // 'Content-Type' is automatically set by axios when using FormData
          },
        }
      );
  
      // Hide the loader
      Swal.close();
  
      // Handle the response
      if (response.data.statusCode === 200) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: response?.data?.message,
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/chargers`);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `Failed to update station. Status: ${response.data.statusCode}`,
        });
      }
    } catch (error) {
      // Hide the loader
      Swal.close();
  
      console.error("Error in AddCharger:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error.response?.data?.message || "An unexpected error occurred.",
      });
    }
  };
  
  useEffect(() => {
    const ChargingTypesData = async () => {
      setLoading(true);
      const apiEndpoint = `${BaseURL}/master/station_charger-0`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("ocpps response", response);
        setchargingTypesData(response?.data?.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };

    ChargingTypesData();
  }, []);
  console.log("PowerListing", PowerListing);
  console.log("chargingTypesData", chargingTypesData);
  console.log("ConnectorsType", ConnectorsType);
  console.log("selectAmenity......", selectAmenity);
  // console.log("selectedConnectorIDs", selectedConnectorIDs);
  return (
    <>
      <div className="container-fluid">
        
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <h1 className="page-title"></h1>
              <div className="portlet light bordered">
                <div className="portlet-title row">
                  <div className="caption font-dark col-md-10">
                    <h4 className="caption-subject bold uppercase mx-3">
                      Add Chargers
                    </h4>
                  </div>
                  <div className="caption font-dark col-md-2">
                    <h5 className="caption-subject bold uppercase mx-3">
                      <button className="btn btn-success" onClick={() => navigate(-1)}>
                        Back
                      </button>
                    </h5>
                  </div>
                </div>
                <div className="portlet-body mx-3">
                  <hr style={{ marginTop: "-10px" }} />
                  <div className="row">
                    <div className="col-sm-12">
                      <form
                        className="form-horizontal"
                        encType="multipart/form-data"
                        role="form"
                        method="post"
                        style={{ marginTop: "-20px" }}
                      >
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="name_id" className="col-sm-2 control-label">
                              Charger Name
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleName}
                                value={Name}
                                className="form-control"
                                id="name_id"
                                name="station_name"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                      

                       
                       
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              IMEI Number
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="state"
                                className="form-control"

                                onChange={handleIMEINumberChange}

                              >

                              </input>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              AmarRaja Charger ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                id="city"
                                className="form-control"

                                onChange={handleAmarRajaPoints}

                              />


                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Sim Number
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="text"
                                onChange={handleSimNumberChange}

                                className="form-control"
                                id="VehicleNumber"
                                name="VehicleNumber"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Chip ID
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChipNumberChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleBookingAmountChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Metallic Property
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleChargerMetallicProperty}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="">Select Property</option>
                                <option value="li-ion">Lithium Ion</option>
                                <option value="lead-acid">Lead Acid</option>
                                </select>

                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Booking Cancel Amount
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlecancelBookingAmountChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Estimated Bid Price
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleChargerEstimatedBidPriceChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Tax
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handletaxChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Other Charges
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleotherchargesChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price without GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithoutGSTChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Per Unit Price with GST
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handlePerUnitPricewithGSTChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Local Hourse
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleLocalHourseChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Security Code
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleSecurityCodeChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                               Charger Type
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleChargerTypeChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Charger Type</option>
                                {chargingTypesData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Charger Conn Type
                            </label>
                            <div className="col-sm-6">
                              <select
                                type="text"
                                className="form-control"
                                id="additionalInput2"
                                name="additionalInput2"
                                onChange={handleConnectorIDChange}
                              >
                                <option value="0">Select Connection Type</option>
                                {ChargerData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
  <div className="row">
    <label htmlFor="connectors_type" className="col-sm-2 control-label">
      Connectors Type
    </label>
    <div className="col-sm-6">
    <Select
          options={connectorOptions} // The options fetched dynamically based on parent_id
          isMulti
          onChange={handleConnectorTypeChange}
          value={selectedConnectors}
          placeholder="Select Connectors Type"
        />
    </div>
    <span className="col-sm-4 control-label"></span>
  </div>
</div>


                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Power
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handlePowerChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Power</option>
                                {PowerListing?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
 <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Amenity
                            </label>
                            <div className="col-sm-6">
                         
                                 <Select
                                isMulti
                                options={AmenitiesTypes}
                                onChange={handleAmenityChange}
                                className="basic-multi-select"
                                classNamePrefix="select"
                                placeholder="Select Amenity"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Select Vechicle
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleVechicleChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              >
                                <option value="0">Select Vehicle</option>
                                {Vehiclesnames?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.title}
                                    </option>
                                  );
                                })}
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                    
                       
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max voltage
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxvoltageChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Max current
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMaxcurrentChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="address_id" className="col-sm-2 control-label">
                              Minimum C One Value
                            </label>
                            <div className="col-sm-6">
                              <input
                                onChange={handleMinimumCOneValueChange}

                                className="form-control"
                                id="address_id"
                                name="address"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>


                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="file_id" className="col-sm-2 control-label">
                              Image
                            </label>
                            <div className="col-sm-6">
                              <input
                                type="file"
                                onChange={handleFileChange}
                                className="form-control"
                                id="file_id"
                                name="user_image"
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                   



                        <div className="form-group">
                          <div className="col-sm-offset-2 col-sm-8 add-class">
                            <input
                              type="button"
                              className="btn btn-success"
                              onClick={AddCharger}
                              value="Add Charger"
                            />
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Add;
